module.exports = "/packs/media/images/detail-fill-in-25b72cc8c5c62033c1a4c175cb58a2bd.png";